import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import useMobileView from '@/hooks/ui/useMobileView';
import useCurrentUser from '@/lib/hooks/useCurrentUser';
import EntityDetails from '@/modules/EntityDetails';
import { LayoutContext } from './LayoutProvider';
import MobileNavigation from './MobileNavigation';
import Sidebar from './Sidebar';
import SuperAdminHeader from './SuperAdminHeader';

function Layout({ children }) {
  const { isExpanded } = React.useContext(LayoutContext);
  const isMobile = useMobileView();
  const { isSuperAdmin } = useCurrentUser();

  return (
    <>
      <div
        className={classNames(
          'mx-auto grid min-h-full grid-cols-[100%] transition-all duration-300',
          {
            'Layout__Grid--sa': isSuperAdmin,
            Layout__Grid: !isSuperAdmin,
            'md:grid-cols-[216px_calc(100%-216px)]': isExpanded,
            'md:grid-cols-[64px_calc(100%-64px)]': !isExpanded,
            'grid-rows-[48px_56px_auto]': isSuperAdmin,
            'grid-rows-[0px_auto]': !isSuperAdmin,
            'md:grid-rows-none': !isSuperAdmin,
            'md:grid-rows-[64px_auto]': isSuperAdmin,
          },
        )}
        data-testid="app-layout"
      >
        {isSuperAdmin && <SuperAdminHeader />}
        {isMobile ? <MobileNavigation /> : null}

        <Sidebar />

        <div
          className={classNames(
            'duration-300 [grid-area:main_/_main_/_main_/_main]',
            {
              'pt-0': isSuperAdmin,
              'pt-14 md:pt-0': !isSuperAdmin,
            },
          )}
        >
          <main className="h-full">{children}</main>
        </div>
      </div>
      <EntityDetails />
    </>
  );
}

Layout.propTypes = {
  children: PropTypes.node,
};

Layout.defaultProps = {
  children: null,
};

export default Layout;
